<template>
  <v-alert
    class="align-self-stretch d-flex align-center"
    color="textColor"
    outlined
    :style="alertStyles"
  >
    <div v-if="fieldErrors.length">
      <ul>
        <li
          class="mb-2 mr-2"
          v-for="fieldError in fieldErrors"
          :key="fieldError.selector"
        >
          {{ fieldError.message }} &nbsp;
          <ScrollTo
            :label="t$('.change')"
            :target-id="fieldError.selector"
            type="hyperlink"
            color="primary"
          />
        </li>
      </ul>
    </div>
    <div v-else-if="error">
      <ul>
        <li class="mb-2">{{ error }}</li>
      </ul>
    </div>
    <div v-else-if="tipp">
      <FormAlertTipp :alert-tipp="tipp" />
    </div>
    <div v-else>{{ defaultMessage }}</div>
  </v-alert>
</template>

<script lang="ts">
import Vue from "vue"
import ScrollTo from "components/UI/ScrollTo.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"
import FormAlertTipp, { Tipp } from "features/common/forms/FormAlertTipp.vue"

export type FieldError = {
  selector: string
  message: string
}

export default Vue.extend({
  name: "FormAlert",
  components: { FormAlertTipp, ScrollTo },
  props: {
    customClass: { type: String, default: "" },
    color: { type: String, required: false },
    width: { type: String, default: "100%" },
    fieldErrors: {
      type: Array as () => FieldError[],
      required: false,
      default: () => [],
    },
    error: { type: String, required: false },
    tipp: { type: Object as () => Tipp, required: false },
    defaultMessage: { type: String, required: false },
  },
  computed: {
    formAlertType(): "error" | "default" {
      return !!this.fieldErrors.length || !!this.error ? "error" : "default"
    },
    alertStyles(): object {
      return {
        fontFamily: "system-ui !important",
        fontSize: "1rem",
        width: this.width,
        margin: 0,
        textWrap: "wrap",
        wordBreak: "break-word",
        height: "100%",
        ...(this.formAlertType === "error"
          ? this.errorAlertStyles
          : this.defaultAlertStyles),
      }
    },
    defaultAlertStyles(): object {
      return {
        borderColor: `${
          this.color || this.$vuetify.theme.themes.light.mediumGrey
        } !important`,
        color: `${
          this.color || this.$vuetify.theme.themes.light.darkGrey
        } !important`,
      }
    },
    errorAlertStyles(): object {
      return {
        borderColor: `${this.$vuetify.theme.themes.light.error} !important`,
        color: `${this.$vuetify.theme.themes.light.error} !important`,
      }
    },
  },
  setup() {
    const { t$ } = useTranslate("common")
    return {
      t$,
    }
  },
})
</script>
